import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { BloodPressureResponseDto, ValueOf } from 'types/types';
import { getPatientsBloodPressure, getBloodPressure } from './actions';
import { DataStatus } from 'types/enums';

export interface State {
  status: ValueOf<typeof DataStatus>;
  bloodPressure: null | BloodPressureResponseDto[];
  patientsBloodPressure: null | PromiseSettledResult<BloodPressureResponseDto[]>[];
}

const initialState: State = {
  status: DataStatus.IDLE,
  bloodPressure: null,
  patientsBloodPressure: null,
};

const { reducer, actions } = createSlice({
  name: 'ecgCapture',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getPatientsBloodPressure.fulfilled, (state, { payload }) => {
      state.status = DataStatus.SUCCEEDED;
      state.patientsBloodPressure = payload;
    });
    builder.addCase(getBloodPressure.fulfilled, (state, { payload }) => {
      state.status = DataStatus.SUCCEEDED;
      state.bloodPressure = payload;
    });
    builder.addMatcher(isAnyOf(getPatientsBloodPressure.pending, getBloodPressure.pending), (state) => {
      state.status = DataStatus.LOADING;
    });
    builder.addMatcher(isAnyOf(getPatientsBloodPressure.rejected, getBloodPressure.rejected), (state) => {
      state.status = DataStatus.FAILED;
    });
    builder.addMatcher(isAnyOf(getPatientsBloodPressure.pending, getPatientsBloodPressure.rejected), (state) => {
      state.patientsBloodPressure = [];
    });
  },
});

export { reducer, actions };
